import React from 'react';
import PropTypes from 'prop-types';
import { track } from '../modules/tracking';
import {
    BETA_MENU_TITLE,
    BETA_MENU_TEXT,
    //BETA_MENU_LINK,
    START_ORDER
} from '../modules/constants';

/**
 * Displays the top banner text and link to the FAQ.
 *
 * @function
 * @constructor
 */
function TopBanner({ market }) {
    const orderLink =
        market === 'UK'
            ? 'https://www.nandos.co.uk/order/search'
            : 'https://www.nandos.ie/order/search';
    return (
        <div
            className='topBanner'
            data-ga-dmt='header_bm'
            data-ga-location='header_bm'
            data-ga-display='static panel'
        >
            <div className='vcenter'>
                <h1>{BETA_MENU_TITLE}</h1>
                <p>{BETA_MENU_TEXT}</p>
                <p className='cta-container'>
                    <a
                        className='cta'
                        href={orderLink}
                        data-ga-dmt-cta='header_bm'
                        data-ga-location='header_bm'
                        data-ga-display='static panel'
                        data-ga-action='clickable'
                        onClick={track(
                            'TopBanner: Click: Open: Start your order CTA'
                        )}
                    >
                        {START_ORDER}
                    </a>
                </p>
            </div>
        </div>
    );
}

TopBanner.propTypes = {
    market: PropTypes.string
};

export { TopBanner };
